import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'gdx-page-not-found',
    templateUrl: './page-not-found.component.html',
    standalone: false
})
export class PageNotFoundComponent {}
